import React, {PureComponent as Component} from 'react';


import {Helmet} from "react-helmet";


class Page404 extends Component{

    componentDidMount() {
        document.body.className ='full-page' ;

    }

    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <meta name="viewport" content="width=device-width, initial-scale=1" />
                    <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
                    <meta name="robots" content="noindex" />
                    <title>
                        404
                    </title>
                    <style>
                        @import url("/css/color.css");
                        @import url("/css/all.css");
                        @import url("/css/card.css");
                        @import url("/css/customStyle.css");
                        @import url("/css/theme.css");
                    </style>
                </Helmet>
                <div className="container-fluid p-0 h-100 bg-full">
                    <div className="row  no-gutters h-100 position-relative">
                        <div className="col col-12  col-sm-12  col-md-5 col-lg-4 part14-2   text-right    ">
                            <div className=" ml-60 d-flex   h-100 align-items-center justify-content-center pl-sm-0 pr-sm-4  ">
                                <div className=" part14-3 part141-2 text-center  p-sm-3 p-md-5 ">
                                    <h3 className="text-white">
                                        خطای
                                    </h3>
                                    <h4 className="text-white">
                                        ۴۰۴
                                    </h4>
                                    <p className="text-right text-white">
                                        با عرض پوزش
                                        :
                                        متاسفانه
                                        ما صفحه مورد نظر شما را پیدا نکردیم.
                                    </p>
                                    <a href="/" className="  btn d-block nav-link line-h-1_9  text-white  ">
                                        بازگشت به صفحه نخست
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col col-12  col-sm-12  col-md-7 col-lg-8  part14 h-100 ">
                            <div className=" w-100 part141   h-100 ">
                                <img className="img w-100  h-100" src="/images/bg-2.jpeg" alt=""  />
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
      }
}

export default Page404;
